import { Typography } from "@/components";
import ChatBubbleTwoToneIcon from "@mui/icons-material/ChatBubbleTwoTone";
import Button from "@mui/material/Button";

interface EmptyChatProps {
	title?: string;
	addLabel?: string;
	onClickAdd?: React.MouseEventHandler<HTMLButtonElement>;
}

const EmptyChat = (props: EmptyChatProps) => {
	const { title = "No chat yet", addLabel, onClickAdd } = props;
	return (
		<div className="h-full flex flex-col justify-center items-center gap-3">
			<div className="bg-white p-5 rounded-[3rem]">
				<ChatBubbleTwoToneIcon className="!text-[5rem] !text-zinc-500" />
			</div>
			<Typography fontWeight={700} fontSize={16}>
				{title}
			</Typography>
			{onClickAdd && addLabel ? (
				<Button
					variant="contained"
					color="primary"
					className="!h-12 !rounded-full"
					onClick={onClickAdd}
				>
					{addLabel}
				</Button>
			) : null}
		</div>
	);
};

export default EmptyChat;
